import React, { useRef } from 'react';
import { useContent } from '../../context/ContentContext';
import { getEditorImageDefault } from '../../data/editorImageDefaults';
import { promptImageUrl, readImageFile } from '../../utils/imageUpload';

export default function EditorPanelImageDetail({ contentKey }) {
  const { getContent, setContentValue, clearContentValue } = useContent();
  const fileInputRef = useRef(null);
  const defaultSrc = getEditorImageDefault(contentKey);
  const displaySrc = getContent(contentKey, defaultSrc);

  const applyFile = async (file) => {
    if (!file) return;
    try {
      const dataUrl = await readImageFile(file);
      setContentValue(contentKey, dataUrl);
    } catch (error) {
      window.alert(error.message);
    }
  };

  return (
    <div className="editor-panel__detail" onClick={(e) => e.stopPropagation()}>
      <div className="editor-panel__detail-image-preview">
        {displaySrc ? <img src={displaySrc} alt="" /> : <span className="editor-panel__detail-thumb-placeholder" />}
      </div>

      <label className="editor-panel__detail-label" htmlFor={`${contentKey}-image-url`}>
        Image URL
      </label>
      <input
        id={`${contentKey}-image-url`}
        type="url"
        className="editor-panel__detail-input"
        value={displaySrc}
        placeholder="https://..."
        onChange={(e) => setContentValue(contentKey, e.target.value)}
      />

      <div className="editor-panel__detail-btn-row">
        <button type="button" className="editor-panel__detail-btn" onClick={() => fileInputRef.current?.click()}>
          Upload image
        </button>
        <button
          type="button"
          className="editor-panel__detail-btn"
          onClick={() => {
            const url = promptImageUrl();
            if (url) setContentValue(contentKey, url);
          }}
        >
          Paste URL
        </button>
        <button
          type="button"
          className="editor-panel__detail-btn editor-panel__detail-btn--danger"
          onClick={() => {
            if (window.confirm('Reset this image to the original?')) {
              clearContentValue(contentKey);
            }
          }}
        >
          Reset
        </button>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        className="editable-image-input"
        onChange={(e) => {
          applyFile(e.target.files?.[0]);
          e.target.value = '';
        }}
      />
    </div>
  );
}
